// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var ZIP = function ZIP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zip-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 18.125h4.375V20H2.5A2.5 2.5 0 0 1 0 17.5v-15C0 1.121 1.121 0 2.5 0h6.465c.664 0 1.3.262 1.77.73l3.535 3.536a2.5 2.5 0 0 1 .73 1.77v5.839h-1.875V6.25H10c-.691 0-1.25-.559-1.25-1.25V1.875H2.5a.627.627 0 0 0-.625.625v15c0 .344.281.625.625.625m6.875-4.375h2.5a.628.628 0 0 1 .559.906l-2.047 4.094h1.488c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625h-2.5a.628.628 0 0 1-.559-.906L10.863 15H9.375a.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625m5.625.625v5a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625v-5c0-.344.281-.625.625-.625s.625.281.625.625m1.25 0c0-.344.281-.625.625-.625h.938a2.189 2.189 0 0 1 0 4.375H17.5v1.25a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625v-5m1.25 2.5h.313c.519 0 .937-.418.937-.937a.935.935 0 0 0-.937-.938H17.5z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zip-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
